import { render, staticRenderFns } from "./DetailCreateModal.vue?vue&type=template&id=07bb37b8&scoped=true"
import script from "./DetailCreateModal.vue?vue&type=script&lang=js"
export * from "./DetailCreateModal.vue?vue&type=script&lang=js"
import style0 from "./DetailCreateModal.vue?vue&type=style&index=0&id=07bb37b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bb37b8",
  null
  
)

export default component.exports